import { DropdownMenuItem } from "@/components/ui/dropdown-menu"
import { useActiveThemeId, useThemeCatalogVersion } from "@/lib/theme-store"
import { cn } from "@/lib/utils"
import {
  applyTheme,
  getThemeIds,
  getThemeLabel,
  getThemePrimaryColor,
} from "@/styles/themes"
import { oklch } from "@/styles/themes/utils"
export function ThemeSwitcher({ className }: { className?: string }) {
  const activeId = useActiveThemeId()
  useThemeCatalogVersion()
  const ids = getThemeIds()

  return (
    <div className={cn("flex items-center gap-1.5", className)}>
      {ids.map((id) => {
        const isActive = id === activeId
        const primary = getThemePrimaryColor(id)
        const label = getThemeLabel(id)

        if (!primary) return null

        return (
          <button
            key={id}
            type="button"
            aria-label={label}
            aria-pressed={isActive}
            title={label}
            onClick={() => {
              if (id !== activeId) applyTheme(id)
            }}
            className={cn(
              "size-5 shrink-0 cursor-pointer rounded-full transition-transform hover:scale-110",
              isActive ? "ring-2 ring-foreground" : "ring-1 ring-foreground/20",
            )}
            style={{ backgroundColor: oklch(primary.l, primary.c, primary.h) }}
          />
        )
      })}
    </div>
  )
}

export function ThemeSwitcherMenuItems() {
  const activeId = useActiveThemeId()
  useThemeCatalogVersion()
  const ids = getThemeIds()

  return (
    <>
      {ids.map((id) => {
        const isActive = id === activeId
        const primary = getThemePrimaryColor(id)

        if (!primary) return null

        return (
          <DropdownMenuItem
            key={id}
            aria-current={isActive || undefined}
            onClick={() => {
              if (!isActive) applyTheme(id)
            }}
          >
            <span
              aria-hidden
              className="size-3 shrink-0 rounded-full ring-1 ring-foreground/20"
              style={{
                backgroundColor: oklch(primary.l, primary.c, primary.h),
              }}
            />
            {getThemeLabel(id)}
            {isActive && (
              <span className="ml-auto text-xs text-muted-foreground">
                Current
              </span>
            )}
          </DropdownMenuItem>
        )
      })}
    </>
  )
}
